import axios from "axios";
import { Base64 } from "js-base64";

const API_URL = process.env.REACT_APP_CORE_SERVER;
const G2_DOMAIN = process.env.REACT_APP_G2DOMAIN;

const getParamUrl = () => {
  let search = window.location.search;
  let arr = search.split("?");
  let params = new URLSearchParams(arr[1]);
  let token = params.get("token");

  if (!token) {
    const tokenPath = window.location.pathname
      .split("/")
      .filter(Boolean)
      ?.pop()
      ?.split(".")
      ?.filter(Boolean)
      ?.pop();

    token = tokenPath;
  }
  return token;
};

const Header = {
  Authorization: `bearer ${getParamUrl()}`,
};

async function apiCall(method, url, data) {
  var data_base64 = Base64.encode(JSON.stringify(data));

  try {
    const res = await axios({
      method: method,
      url: API_URL + url,
      data: {
        data: data_base64,
      },
      headers: Header,
    });
    return res?.data;
  } catch (err) {
    return err?.response?.data;
  }
}

async function apiUpload(method, url, data) {
  const res = await axios({
    method: method,
    url: G2_DOMAIN + url,
    data,
    headers: Header,
  });
  return res;
}

const api = { apiCall, apiUpload };
export default api;
